// extracted by mini-css-extract-plugin
export var center = "_1u-2";
export var clickableRow = "_1u-5";
export var expandedRow = "_1u-7";
export var hoverable = "_1u-4";
export var left = "_1u-1";
export var right = "_1u-3";
export var row = "_1u-0";
export var selectedRow = "_1u-6";
export var summaryRow = "_1u-8";